var _defs, _g, _g2, _g3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCardFrontShapedFinal(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 800 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-17{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3{opacity:0.25;}.cls-10,.cls-11,.cls-13,.cls-4,.cls-9{fill:#afafaf;}.cls-5{clip-path:url(#clip-path-2);}.cls-6{clip-path:url(#clip-path-3);}.cls-7{fill:#2c293b;}.cls-8{opacity:0.2;}.cls-9{opacity:0.8;}.cls-10{opacity:0.6;}.cls-11{opacity:0.7;}.cls-12,.cls-13{opacity:0.5;}.cls-14{fill:#131219;opacity:0.4;}.cls-15{opacity:0.3;}.cls-16,.cls-18{fill:#b9ad8a;}.cls-16{stroke:#afafaf;stroke-miterlimit:10;}.cls-16,.cls-17{stroke-width:2.06px;}.cls-17{stroke:#b9ad8a;stroke-linecap:round;stroke-linejoin:round;}.cls-18,.cls-20{font-size:38.78px;}.cls-18,.cls-20,.cls-23{font-family:TitilliumWeb-Regular, Titillium Web;}.cls-19{letter-spacing:0em;}.cls-20,.cls-23{fill:#cbcbcb;}.cls-21{letter-spacing:-0.01em;}.cls-22{letter-spacing:0em;}.cls-23{font-size:21.52px;}.cls-24{letter-spacing:0em;}.cls-25{letter-spacing:0em;}.cls-26{letter-spacing:-0.01em;}.cls-27{letter-spacing:-0.01em;}.cls-28{letter-spacing:0em;}.cls-29{letter-spacing:-0.03em;}.cls-30{clip-path:url(#clip-path-4);}.cls-31{clip-path:url(#clip-path-5);}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -819.51,
    y: -0.02,
    width: 799,
    height: 500
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 8,
    y: 9,
    width: 784,
    height: 482,
    rx: 22.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: -0.07,
    width: 800,
    height: 500
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 828,
    y: 9,
    width: 784,
    height: 482,
    rx: 22.48
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 820.49,
    y: -0.02,
    width: 799,
    height: 500
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "card-back-final"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M4.57,116.31h157l-8.63,8.63H-25.46L-113,37.42H-250.16l-29.42,29.41h-38.63l35.29-35.29h202.7ZM-315.38,65.66h35.32l29.41-29.42h138.16L-25,123.76H152.44l6.28-6.28H4.09l-84.8-84.77H-282.43ZM-267,45h-20.44l4.44-4.44h20.44Zm-17.61-1.17h17.12l2.1-2.1H-282.5ZM-273,51h-20.44l4.44-4.44h20.44Zm-17.61-1.17h17.13l2.09-2.09h-17.12ZM-279,57.07h-20.44l4.44-4.44h20.44Zm-17.61-1.17h17.12l2.1-2.1h-17.13Zm11.57,7.2h-20.44l4.44-4.44h20.44Zm-17.61-1.17h17.13l2.09-2.1H-300.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M142,165.34H29.56L-31.6,104.18H-177.47l-24.61,24.62h26.67l21.22-21.22h99.31L8.25,170.71H136.58Zm-332.52-41.59H-177l-2.35,2.36h-13.55Zm4.35-4.35h13.55l-2.36,2.36h-13.55Zm4.35-4.36h13.55l-2.36,2.36h-13.54Zm17.9-4.35-2.35,2.36h-13.55l2.36-2.36Z"
  }))))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "card-front-shaped-final"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: -0.07,
    width: 800,
    height: 500
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M471.32-4.12l-20,13.59a322.55,322.55,0,0,1,56,181.7,327.13,327.13,0,0,1-5.8,61.15l-.16.78L525.22,257a350.61,350.61,0,0,0,6.27-65.85A346.6,346.6,0,0,0,471.32-4.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M183.33,515.87a327.69,327.69,0,0,1-61.09-5.79l-.8-.16-4,23.88a351.44,351.44,0,0,0,65.85,6.27,346.64,346.64,0,0,0,194.94-59.94l-13.57-20A322.52,322.52,0,0,1,183.33,515.87Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M423.18-48.5l-24,24a303.71,303.71,0,0,1,89.46,216.09v1h33.88v-1A337.36,337.36,0,0,0,423.18-48.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M182.62,497.26h-.36v33.88h.7a337.47,337.47,0,0,0,239.52-98.85l-23.9-24C340.91,465.66,264.33,497.26,182.62,497.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M292-48.18v16.07C374.71,8.38,431.81,93.41,431.81,191.54c0,137.22-111.63,248.85-248.85,248.85C100.39,440.39,27.09,400-18.2,337.85c-2.43,4.66-5.1,9.25-7.64,14C22.35,414.47,98,454.91,183,454.91c145.23,0,263.37-118.15,263.37-263.37C446.33,85.19,383-6.64,292-48.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183-106.51c-164.34,0-298,133.7-298,298.05s133.71,298,298.05,298S481,355.89,481,191.54,347.31-106.51,183-106.51Zm0,593.68c-163,0-295.63-132.62-295.63-295.63S20-104.09,183-104.09,478.6,28.53,478.6,191.54,346,487.17,183,487.17Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M183,580.34v-29c1.56,0,3.12,0,4.67,0l.34,29Q185.48,580.34,183,580.34Zm10.07-.13-.77-29L197,551l1,29Zm10-.38-1.45-29c1.56-.08,3.11-.17,4.66-.27l1.79,29C206.37,579.65,204.7,579.75,203,579.83Zm10-.64-2.22-29q2.34-.18,4.65-.39l2.56,28.93C216.41,578.93,214.74,579.06,213.08,579.19Zm10-.9-3-28.89c1.55-.16,3.09-.32,4.64-.5l3.32,28.85Q225.59,578,223.1,578.29Zm10-1.16-3.74-28.79,4.67-.64,4,28.77Zm9.92-1.4L238.6,547l4.6-.74L248,574.93Zm9.93-1.67-5.19-28.58c1.53-.27,3.06-.56,4.58-.86l5.53,28.51Q255.41,573.61,253,574.06Zm9.88-1.94-6-28.42,4.6-1,6.22,28.37Zm9.79-2.17L266,541.68l4.54-1.1,7,28.19C275.87,569.17,274.24,569.57,272.62,570Zm9.77-2.45L275,539.43l4.5-1.22,7.74,28C285.62,566.64,284,567.08,282.39,567.5Zm9.7-2.69-8.16-27.87,4.5-1.34,8.44,27.78Zm9.63-2.95-8.87-27.65c1.49-.47,3-1,4.46-1.46l9.18,27.55Q304.12,561.1,301.72,561.86Zm9.56-3.2-9.57-27.42c1.47-.51,2.93-1,4.39-1.56L316,557C314.47,557.54,312.87,558.11,311.28,558.66Zm9.48-3.45-10.27-27.16c1.46-.55,2.91-1.12,4.36-1.69l10.6,27C323.89,554,322.33,554.62,320.76,555.21Zm9.41-3.71-11-26.87c1.46-.59,2.9-1.2,4.34-1.81l11.3,26.75C333.25,550.22,331.71,550.87,330.17,551.5Zm9.28-3.94L327.74,521q2.14-.93,4.27-1.91l12,26.43C342.51,546.2,341,546.88,339.45,547.56Zm9.17-4.18-12.37-26.27,4.18-2,12.75,26.08C351.67,541.94,350.15,542.66,348.62,543.38Zm9.06-4.42L344.63,513l4.13-2.12,13.42,25.75C360.69,537.44,359.19,538.2,357.68,539Zm9-4.66-13.76-25.57c1.36-.74,2.73-1.48,4.09-2.24l14.09,25.39Q368.85,533.11,366.64,534.3Zm8.81-4.88L361,504.22c1.34-.77,2.68-1.55,4-2.33l14.8,25Q377.66,528.16,375.45,529.42Zm8.67-5.1-15.05-24.84q2-1.2,4-2.43l15.38,24.63Q386.28,523,384.12,524.32Zm8.55-5.33L377,494.55c1.31-.84,2.61-1.68,3.91-2.54l16,24.24Zm8.4-5.54-16.31-24q1.94-1.32,3.84-2.65l16.6,23.83Q403.15,512,401.07,513.45Zm8.24-5.76L392.4,484.08c1.27-.91,2.52-1.82,3.78-2.74l17.19,23.41C412,505.73,410.67,506.72,409.31,507.69Zm8.11-6-17.53-23.15c1.23-.94,2.46-1.88,3.69-2.84l17.83,22.93C420.09,499.69,418.75,500.71,417.42,501.72Zm7.94-6.17-18.11-22.7,3.64-3,18.35,22.51Q427.3,494,425.36,495.55Zm7.79-6.39L414.43,467l3.58-3,18.94,22Q435.06,487.55,433.15,489.16Zm7.6-6.56-19.27-21.73,3.47-3.11,19.53,21.49C443.24,480.38,442,481.49,440.75,482.6Zm7.42-6.76L428.38,454.6l3.34-3.16,20.14,20.91Q450,474.12,448.17,475.84Zm7.28-7-20.36-20.7c1.1-1.09,2.21-2.18,3.3-3.29L459,465.34C457.83,466.53,456.64,467.71,455.45,468.88Zm7.07-7.13-20.87-20.19c1.06-1.1,2.12-2.2,3.17-3.32L466,458.08C464.87,459.31,463.7,460.54,462.52,461.75Zm6.88-7.3L448,434.79c1-1.13,2.08-2.28,3.1-3.43l21.66,19.35C471.67,452,470.54,453.21,469.4,454.45Zm6.71-7.5-21.89-19.08c1-1.17,2-2.34,3-3.53l22.13,18.81C478.29,444.42,477.21,445.69,476.11,447Zm6.51-7.67-22.4-18.48c1-1.2,2-2.41,3-3.62l22.59,18.24Q484.21,437.35,482.62,439.28Zm6.3-7.81-22.86-17.91q1.44-1.83,2.85-3.68L492,427.51Q490.46,429.51,488.92,431.47Zm6.09-8-23.3-17.32q1.4-1.87,2.75-3.76L498,419.47C497,420.82,496,422.17,495,423.5Zm5.89-8.12-23.73-16.73,2.66-3.82,23.93,16.44C502.82,412.65,501.86,414,500.9,415.38Zm5.67-8.27L482.42,391,485,387.1l24.34,15.83C508.41,404.33,507.5,405.73,506.57,407.11ZM512,398.7l-24.54-15.51q1.23-1.95,2.43-3.93l24.78,15.16Q513.38,396.57,512,398.7Zm5.25-8.56-24.95-14.87c.8-1.32,1.58-2.66,2.36-4l25.12,14.57C519,387.27,518.13,388.71,517.28,390.14Zm5-8.7L497,367.27q1.13-2,2.24-4.06L524.73,377C523.94,378.51,523.12,380,522.31,381.44Zm4.77-8.78L501.41,359.1c.72-1.37,1.43-2.73,2.12-4.1l25.87,13.2Q528.26,370.44,527.08,372.66Zm4.57-8.93-26-12.89q1-2.07,2-4.14l26.21,12.5Q532.77,361.47,531.65,363.73Zm4.32-9-26.34-12.23q1-2.07,1.89-4.16l26.55,11.78Q537,352.4,536,354.7Zm4.09-9.15L513.41,334c.61-1.41,1.21-2.81,1.79-4.23L542,340.9Q541.07,343.23,540.06,345.55Zm3.86-9.26-27-10.8c.59-1.45,1.15-2.9,1.72-4.34l27.08,10.47C545.16,333.18,544.54,334.74,543.92,336.29Zm3.61-9.37L520.32,316.8c.53-1.45,1.06-2.89,1.58-4.34l27.36,9.71C548.7,323.76,548.13,325.34,547.53,326.92Zm3.39-9.5-27.49-9.36,1.5-4.46,27.57,9.11Zm3.13-9.53-27.7-8.69c.46-1.47.91-2.95,1.36-4.44l27.82,8.31C555,304.69,554.55,306.29,554.05,307.89Zm2.89-9.66L529,290.31l1.26-4.52,28,7.64C557.83,295,557.39,296.64,556.94,298.23Zm2.61-9.68-28.12-7.24c.39-1.5.77-3,1.14-4.51l28.2,6.88C560.38,285.31,560,286.94,559.55,288.55Zm2.39-9.78-28.32-6.48,1-4.58,28.37,6.2Zm2.11-9.8-28.45-5.8c.3-1.51.6-3,.89-4.57L565,264C564.7,265.69,564.38,267.33,564.05,269Zm1.87-9.9-28.61-5c.27-1.53.53-3.05.77-4.56l28.67,4.6C566.49,255.75,566.2,257.41,565.92,259.07Zm1.6-9.93-28.72-4.27c.22-1.53.44-3.07.65-4.61l28.78,3.9C568,245.83,567.77,247.48,567.52,249.14Zm1.35-10L540,235.67l.55-4.67,28.86,3.22Zm1.09-10-28.91-2.82c.16-1.54.29-3.09.43-4.64l28.93,2.46C570.27,225.87,570.12,227.54,570,229.2Zm.84-10-29-2c.11-1.55.21-3.1.3-4.66l29,1.71C571,215.83,570.92,217.5,570.8,219.17Zm.57-10-29-1.29c.07-1.54.13-3.09.18-4.64l29,.93C571.51,205.8,571.45,207.47,571.37,209.13Zm.32-10-29-.6c0-1.56,0-3.11.06-4.66l29,.25C571.74,195.8,571.72,197.47,571.69,199.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M-176.79,189.16l-29-.17c0-1.68,0-3.36.06-5l29,.55Q-176.77,186.84-176.79,189.16Zm.18-9.28-29-.94c.06-1.66.12-3.33.19-5l29,1.28C-176.5,176.78-176.56,178.33-176.61,179.88Zm.41-9.29-29-1.66c.1-1.68.2-3.35.32-5l29,2C-176,167.49-176.11,169-176.2,170.59Zm.65-9.28-28.94-2.42c.14-1.66.29-3.33.45-5l28.91,2.77C-175.28,158.21-175.42,159.76-175.55,161.31Zm.89-9.27-28.86-3.14c.18-1.67.37-3.34.57-5l28.83,3.53C-174.31,149-174.49,150.5-174.66,152Zm1.13-9.22-28.78-3.91c.23-1.66.47-3.32.71-5l28.72,4.26C-173.1,139.74-173.32,141.27-173.53,142.82Zm1.37-9.21L-200.83,129c.27-1.66.55-3.31.84-5l28.6,5C-171.66,130.55-171.91,132.08-172.16,133.61Zm1.61-9.18-28.55-5.35c.32-1.65.64-3.3,1-5l28.46,5.75C-170,121.4-170.27,122.91-170.55,124.43Zm1.84-9.1-28.39-6.12c.35-1.64.72-3.27,1.09-4.9l28.31,6.47C-168,112.29-168.38,113.81-168.71,115.33Zm2.08-9.07-28.23-6.84q.6-2.46,1.23-4.89l28.12,7.23C-165.9,103.26-166.27,104.76-166.63,106.26Zm2.3-9-28-7.61c.44-1.62.88-3.23,1.34-4.84l27.93,8C-163.5,94.28-163.92,95.77-164.33,97.27Zm2.55-9L-189.6,80c.48-1.6,1-3.21,1.47-4.8l27.72,8.68C-160.88,85.35-161.33,86.84-161.78,88.32Zm2.79-8.9-27.61-9c.53-1.61,1.06-3.2,1.61-4.8L-157.52,75C-158,76.49-158.51,78-159,79.42Zm3-8.79-27.36-9.73q.84-2.38,1.73-4.75l27.21,10.13C-154.93,67.73-155.46,69.17-156,70.63Zm3.24-8.71-27.09-10.46c.6-1.57,1.22-3.13,1.84-4.68l27,10.81C-151.62,59-152.18,60.47-152.74,61.92Zm3.45-8.6-26.8-11.19q1-2.3,2-4.59L-147.48,49C-148.09,50.46-148.7,51.89-149.29,53.32Zm3.68-8.52L-172.13,33c.69-1.52,1.38-3.05,2.08-4.57L-143.7,40.6Q-144.68,42.69-145.61,44.8Zm3.88-8.4-26.19-12.54c.73-1.52,1.46-3,2.2-4.52l26,12.9Q-140.72,34.31-141.73,36.4Zm4.11-8.31-25.85-13.22c.76-1.48,1.52-3,2.3-4.44L-135.48,24Q-136.56,26-137.62,28.09Zm4.33-8.21L-158.8,6q1.2-2.2,2.43-4.4L-131,15.83Q-132.18,17.86-133.29,19.88Zm4.54-8.09L-153.89-2.74c.84-1.45,1.68-2.88,2.54-4.32L-126.4,7.79Q-127.58,9.78-128.75,11.79Zm4.75-8-24.77-15.15c.88-1.43,1.76-2.86,2.65-4.27L-121.55-.13Q-122.78,1.84-124,3.81ZM-119-4l-24.38-15.77c.91-1.41,1.84-2.81,2.77-4.21L-116.5-7.9C-117.35-6.63-118.2-5.34-119-4Zm5.14-7.7-23.94-16.44c1-1.38,1.9-2.75,2.87-4.11l23.72,16.74Q-112.58-13.67-113.9-11.75Zm5.36-7.6-23.52-17c1-1.36,2-2.7,3-4l23.3,17.34Q-107.17-21.23-108.54-19.35Zm5.54-7.44-23.06-17.65q1.53-2,3.07-4l22.84,17.94C-101.11-29.25-102.06-28-103-26.79Zm5.75-7.33-22.62-18.2c1.05-1.31,2.12-2.61,3.19-3.91L-94.32-37.7Q-95.79-35.91-97.25-34.12Zm5.92-7.14-22.13-18.81,3.27-3.8,21.9,19.08Q-89.82-43-91.33-41.26Zm6.12-7-21.65-19.35c1.12-1.25,2.24-2.5,3.38-3.73L-82.1-51.72Q-83.66-50-85.21-48.28Zm6.26-6.82-21.09-20q1.71-1.81,3.44-3.6L-75.71-58.5Zm6.5-6.72L-93.09-82.25c1.18-1.19,2.38-2.38,3.58-3.56l20.34,20.73C-70.27-64-71.36-62.92-72.45-61.82Zm6.62-6.51-20.08-21c1.21-1.15,2.42-2.3,3.65-3.44l19.82,21.22Q-64.15-69.94-65.83-68.33ZM-59-74.69-78.57-96.15q1.86-1.71,3.75-3.37l19.26,21.73Zm7-6.17-19-22c1.27-1.09,2.54-2.18,3.83-3.26l18.69,22.22Q-50.29-82.37-52-80.86Zm7.11-6-18.39-22.47c1.29-1.06,2.59-2.12,3.9-3.16l18.11,22.7C-42.54-88.8-43.74-87.82-44.94-86.84Zm7.28-5.81-17.82-22.93q2-1.55,4-3.07L-34-95.48C-35.21-94.55-36.44-93.6-37.66-92.65Zm7.44-5.63-17.25-23.36q2-1.5,4.08-3L-26.47-101Q-28.36-99.66-30.22-98.28Zm7.57-5.44L-39.3-127.5q2.07-1.45,4.17-2.87l16.3,24Zm7.7-5.22-16-24.22q2.1-1.4,4.22-2.76L-11-111.48C-12.36-110.64-13.65-109.8-14.95-108.94Zm7.83-5-15.36-24.65,4.29-2.64,15,24.85Q-5.14-115.2-7.12-114Zm8-4.83-14.71-25q2.16-1.28,4.35-2.52L4.88-121.13Q2.85-120,.85-118.79Zm8.09-4.63-14.06-25.4,4.42-2.41L13-125.65Zm8.22-4.41L3.75-153.58c1.5-.78,3-1.55,4.49-2.3l13.07,25.93ZM25.49-132l-12.73-26.1c1.51-.74,3-1.46,4.54-2.18L29.69-134Zm8.43-4-12-26.42c1.52-.7,3.06-1.39,4.6-2.06l11.7,26.58C36.75-137.28,35.33-136.64,33.92-136Zm8.53-3.75L31.12-166.49l4.64-1.93,11,26.87Q44.61-140.67,42.45-139.75Zm8.64-3.54-10.64-27,4.7-1.82L55.44-145Q53.27-144.14,51.09-143.29Zm8.74-3.31-10-27.28q2.39-.87,4.77-1.7l9.57,27.41C62.75-147.66,61.29-147.14,59.83-146.6Zm8.81-3.08-9.23-27.53q2.4-.81,4.8-1.58l8.86,27.66C71.59-150.66,70.11-150.18,68.64-149.68Zm8.88-2.85L69-180.3q2.4-.73,4.81-1.44L82-153.86Zm9-2.61-7.8-28q2.43-.67,4.88-1.32l7.39,28.08Zm9-2.37L88.4-185.67q2.44-.62,4.89-1.2L100-158.6C98.46-158.25,97-157.89,95.46-157.51Zm9.05-2.13L98.2-188l4.91-1.06,5.94,28.43C107.53-160.31,106-160,104.51-159.64Zm9.12-1.91L108-190c1.66-.33,3.31-.64,5-.94l5.19,28.57C116.65-162.13,115.14-161.85,113.63-161.55Zm9.12-1.66-4.81-28.63,5-.81,4.46,28.7Zm9.2-1.42-4.08-28.76c1.66-.23,3.32-.46,5-.67l3.69,28.8C135-165.06,133.48-164.85,132-164.63Zm9.22-1.19-3.32-28.85c1.65-.19,3.32-.37,5-.54l3,28.88C144.26-166.17,142.71-166,141.17-165.82Zm9.27-1-2.6-28.92q2.5-.24,5-.42l2.21,29C153.52-167,152-166.91,150.44-166.77Zm9.26-.71-1.83-29c1.66-.11,3.33-.21,5-.29l1.49,29C162.8-167.67,161.25-167.58,159.7-167.48ZM169-168l-1.1-29c1.67-.06,3.35-.11,5-.15l.73,29C172.1-168.07,170.55-168,169-168Zm9.31-.23-.38-29c1.68,0,3.35,0,5,0v29Q180.64-168.22,178.31-168.19Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M40.73,436.41A280.55,280.55,0,0,0,133,470.28l2.54-14.3A265.83,265.83,0,0,1,48,423.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M41.68-53.88A283.67,283.67,0,0,0-33.66,9.22l11.1,9.36A268.82,268.82,0,0,1,48.94-41.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M228.8,456.25l2.46,14.31a280.75,280.75,0,0,0,92.49-33.32l-7.23-12.59A266.23,266.23,0,0,1,228.8,456.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M449.1,94.72l-13.64,5a267.76,267.76,0,0,1,16.11,91.77v1.21h14.52v-1.12A282.09,282.09,0,0,0,449.1,94.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M388.14,364.92l11.08,9.38a281.77,281.77,0,0,0,49.5-84.89l-13.62-5A267.47,267.47,0,0,1,388.14,364.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M399.92,9.61A283.5,283.5,0,0,0,324.7-53.62L317.42-41A269,269,0,0,1,388.8,19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M339.3-20.27l-14.25,7.64c64.49,45,106.76,119.74,106.76,204.17,0,137.22-111.63,248.85-248.85,248.85A248.47,248.47,0,0,1-10,348.53q0,11.09.08,22.17A262.69,262.69,0,0,0,183,454.91c145.23,0,263.37-118.15,263.37-263.37C446.33,104.81,404.18,27.74,339.3-20.27Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M182.72-57.21A247.39,247.39,0,0,0,45.92-16.12a247.9,247.9,0,0,0,65-167.52c0-137.22-111.63-248.85-248.85-248.85S-386.79-320.86-386.79-183.64-275.16,65.21-137.94,65.21A247.39,247.39,0,0,0-1.14,24.12a247.9,247.9,0,0,0-65,167.52c0,137.22,111.63,248.85,248.85,248.85S431.57,328.86,431.57,191.64,319.94-57.21,182.72-57.21Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-15"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 182.96,
    y1: 100.71,
    x2: 310.22,
    y2: 119.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 182.96,
    y1: 100.71,
    x2: 182.96,
    y2: 45.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 182.96,
    y1: 100.71,
    x2: 55.71,
    y2: 119.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 182.96,
    y1: 100.71,
    x2: 103.43,
    y2: 238.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 103.43,
    y1: 238.46,
    x2: 262.5,
    y2: 238.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 262.5,
    y1: 238.46,
    x2: 182.96,
    y2: 100.71
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 262.5,
    y1: 238.46,
    x2: 310.22,
    y2: 119.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 182.96,
    y1: 339.48,
    x2: 262.5,
    y2: 238.46
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 103.43,
    y1: 238.46,
    x2: 182.96,
    y2: 339.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 103.43,
    y1: 238.46,
    x2: 55.71,
    y2: 119.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 262.5,
    y1: 238.46,
    x2: 310.22,
    y2: 266.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-16",
    x1: 103.43,
    y1: 238.46,
    x2: 55.71,
    y2: 266.01
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 182.96,
    y1: 45.6,
    x2: 310.22,
    y2: 119.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 310.22,
    y1: 119.07,
    x2: 310.22,
    y2: 266.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 310.22,
    y1: 266.01,
    x2: 182.96,
    y2: 339.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 182.96,
    y1: 339.48,
    x2: 55.71,
    y2: 266.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 55.71,
    y1: 266.01,
    x2: 55.71,
    y2: 119.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 55.71,
    y1: 119.07,
    x2: 182.96,
    y2: 45.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 182.96,
    y1: 45.6,
    x2: 103.43,
    y2: 146.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 103.43,
    y1: 146.62,
    x2: 55.71,
    y2: 266.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 55.71,
    y1: 266.01,
    x2: 182.96,
    y2: 284.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 182.96,
    y1: 284.38,
    x2: 310.22,
    y2: 266.01
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 310.22,
    y1: 266.01,
    x2: 262.5,
    y2: 146.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 262.5,
    y1: 146.62,
    x2: 182.96,
    y2: 45.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 262.5,
    y1: 146.62,
    x2: 182.96,
    y2: 284.38
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 182.96,
    y1: 284.38,
    x2: 103.43,
    y2: 146.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 182.96,
    y1: 284.38,
    x2: 182.96,
    y2: 339.48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 103.43,
    y1: 146.62,
    x2: 262.5,
    y2: 146.62
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 262.5,
    y1: 146.62,
    x2: 310.22,
    y2: 119.07
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-17",
    x1: 103.43,
    y1: 146.62,
    x2: 55.71,
    y2: 119.07
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-18",
    transform: "translate(531.52 425.78)"
  }, "Se", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 40.6,
    y: 0
  }, "n"), /*#__PURE__*/React.createElement("tspan", {
    x: 61.31,
    y: 0
  }, "tinelX")), /*#__PURE__*/React.createElement("text", {
    className: "cls-20",
    transform: "translate(699.38 425.78)"
  }, "N", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 26.22,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 46.23,
    y: 0
  }, "C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(618 467.06)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24"
  }, "P"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 12.67,
    y: 0
  }, "ow"), /*#__PURE__*/React.createElement("tspan", {
    x: 40.22,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 51.08,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 58.31,
    y: 0
  }, "ed "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-27",
    x: 85.3,
    y: 0
  }, "b"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 96.42,
    y: 0
  }, "y X"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-29",
    x: 123.55,
    y: 0
  }, "Y"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-28",
    x: 134.51,
    y: 0
  }, "O")))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_4",
    "data-name": "Layer 4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-30"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-31"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M879.21,31.54h202.7l35.29,35.29h-38.63l-29.42-29.41H912l-87.51,87.52H646.07l-8.63-8.63h157Zm202.21,1.17H879.7l-84.8,84.77H640.27l6.28,6.28H824l87.52-87.52h138.16l29.41,29.42h35.32Zm-19.89,7.85H1082l4.44,4.44H1066Zm20,1.17h-17.12l2.1,2.1h17.12Zm-13.91,4.86H1088l4.44,4.44H1072Zm20,1.18H1070.4l2.09,2.09h17.12Zm-13.92,4.86H1094l4.44,4.44H1078Zm20,1.17h-17.13l2.1,2.1h17.12Zm-13.92,4.86h20.44l4.44,4.44h-20.44Zm19.95,1.17h-17.12l2.09,2.1h17.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M662.41,170.71H790.74l63.13-63.13h99.31L974.4,128.8h26.67l-24.61-24.62H830.59l-61.16,61.16H657Zm329.51-44.6H978.37L976,123.75h13.54Zm-4.35-4.35H974l-2.36-2.36h13.55Zm-4.36-4.36H969.67L967.31,115h13.55Zm-6.71-6.71,2.36,2.36H965.31L963,110.69Z"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardFrontShapedFinal);
export default __webpack_public_path__ + "static/media/card-front-shaped-final.95da2c53735cc0cc95394e3e63b62dda.svg";
export { ForwardRef as ReactComponent };